import * as Yup from "yup";


export const StrategyName = Yup.object({
  name: Yup.string().min(1).max(30).required("strategy name is required"),
  description: Yup.string().min(5),
});

